import { supabase } from '../../../../src/lib/supabase';
import { normalizeUcCodigo } from '../../../../src/lib/ucCodigo';
import type { UnidadeConsumidora } from '../../../../types';

/**
 * Busca o cadastro completo da UC de uma fatura, para abrir o `UCManagementModal`.
 *
 * `faturas.uc_codigo` é texto livre do robô ('1.500.203.012-60', ' 760000116') e
 * pode estar gravado com o número do dia a dia ou com o código interno da
 * distribuidora — por isso casa pelas colunas normalizadas dos DOIS números
 * (mesmo padrão de BoletoEmitidoModal), e não por igualdade com `numero_uc`.
 *
 * Devolve `null` quando a UC não tem cadastro (número novo da distribuidora que
 * nunca foi recadastrado — ver caso da UC 10021453533).
 */
export async function buscarUcDaFatura(ucCodigo: string | null | undefined): Promise<UnidadeConsumidora | null> {
  const ucNorm = normalizeUcCodigo(ucCodigo);
  if (!ucNorm) return null;
  const { data, error } = await supabase
    .from('unidades_consumidoras')
    .select('*')
    .or(`numero_uc_norm.eq.${ucNorm},outro_numero_uc_norm.eq.${ucNorm}`)
    .limit(1);
  if (error) throw error;
  return (data?.[0] as UnidadeConsumidora | undefined) ?? null;
}
